import { useState } from 'react'
import { format, subDays, startOfMonth, endOfMonth, startOfWeek, endOfWeek } from 'date-fns'

const PRESETS = [
  { label: 'Сегодня', key: 'today' },
  { label: 'Неделя', key: 'week' },
  { label: 'Месяц', key: 'month' },
  { label: 'Произвольно', key: 'custom' },
]

function getPresetDates(key) {
  const today = new Date()
  switch (key) {
    case 'today':
      return { from: today, to: today }
    case 'week':
      return { from: startOfWeek(today, { weekStartsOn: 1 }), to: endOfWeek(today, { weekStartsOn: 1 }) }
    case 'month':
      return { from: startOfMonth(today), to: endOfMonth(today) }
    default:
      return { from: today, to: today }
  }
}

export default function PeriodFilter({ onChange }) {
  const [active, setActive] = useState('month')
  const [custom, setCustom] = useState({
    from: format(new Date(), 'yyyy-MM-dd'),
    to: format(new Date(), 'yyyy-MM-dd'),
  })

  const handlePreset = (key) => {
    setActive(key)
    if (key !== 'custom') {
      const { from, to } = getPresetDates(key)
      onChange({
        date_from: format(from, 'yyyy-MM-dd'),
        date_to: format(to, 'yyyy-MM-dd'),
      })
    }
  }

  const handleCustomApply = () => {
    onChange({ date_from: custom.from, date_to: custom.to })
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {PRESETS.map((p) => (
        <button
          key={p.key}
          onClick={() => handlePreset(p.key)}
          className={`btn-sm px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            active === p.key
              ? 'bg-primary-600 text-white'
              : 'bg-white border border-gray-200 text-gray-600 hover:border-primary-300'
          }`}
        >
          {p.label}
        </button>
      ))}
      {active === 'custom' && (
        <div className="flex items-center gap-2">
          <input
            type="date"
            className="input py-1 text-sm"
            value={custom.from}
            onChange={(e) => setCustom((c) => ({ ...c, from: e.target.value }))}
          />
          <span className="text-gray-400">—</span>
          <input
            type="date"
            className="input py-1 text-sm"
            value={custom.to}
            onChange={(e) => setCustom((c) => ({ ...c, to: e.target.value }))}
          />
          <button onClick={handleCustomApply} className="btn-primary btn-sm">
            Применить
          </button>
        </div>
      )}
    </div>
  )
}
